/**
 * CopyableCode — 书组码 / 书编码内联复制
 *
 * 有值才可点：mono 码 + IconCopy；空值画「—」，不拿 uuid 顶替。
 */

import { type CSSProperties, useState } from 'react';
import { Icons } from '~/lib/icons';
import { toast } from '~/ui/Toast';

export function CopyableCode({
  value,
  label,
  prefix,
  style,
}: {
  value?: string | null;
  label: string;
  prefix?: string;
  style?: CSSProperties;
}) {
  const [hover, setHover] = useState(false);
  const code = value?.trim() || '';
  if (!code) {
    return (
      <span className="mono" style={{ color: 'var(--fg-faint)', fontSize: 11, ...style }}>
        {prefix ? `${prefix} ` : ''}—
      </span>
    );
  }
  return (
    <button
      type="button"
      className="focusable"
      title={`复制${label} ${code}`}
      onClick={(e) => {
        e.stopPropagation();
        void navigator.clipboard.writeText(code);
        toast(`已复制${label} ${code}`, { tone: 'pos', icon: 'IconCopy' });
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        border: 0,
        background: hover ? 'var(--bg-muted)' : 'transparent',
        cursor: 'pointer',
        padding: '1px 4px',
        borderRadius: 5,
        font: 'inherit',
        color: 'var(--fg-muted)',
        ...style,
      }}
    >
      {prefix ? <span style={{ color: 'var(--fg-faint)' }}>{prefix} </span> : null}
      <span className="mono" style={{ fontSize: 11, color: 'var(--fg)' }}>
        {code}
      </span>
      <Icons.IconCopy size={10} style={{ color: 'var(--fg-faint)', flexShrink: 0 }} />
    </button>
  );
}
